import React from 'react';
import moment from 'moment';
import '../../css/formats.css';
import { CURRENCY, Datos_Empresa, FORMAT_NUMBER, SYMBOL } from "../../libs/utils/Const";
import { NumeroLetra } from '../NewOrder';
import { development } from "../../libs/utils/Const";

class TicketCanceled extends React.Component {


    render() {
        const {  DocLines, DocHeader, InfoByFolio } = this.props
        let totalLetra = '';

        let numeroLetra = new NumeroLetra();
        totalLetra = numeroLetra.NumeroALetras("SOL", Number(Number(DocHeader.DocTotal).toFixed(2)));
        
        return (
            <div>
                <div className='row'>
                    <div className='col-4'></div>
                    <div className='col-4'>
                        <div style={{ backgroundColor: 'white', width: "322px", height: "auto", marginLeft: "auto", marginRight: "auto", border: "solid 1px" }}>
                            <div className='row p-3'>
                                <div className='col-12 text-center'>
                                    <span><strong>VENTA CANCELADA</strong></span>
                                </div>
                            </div>
                            <div className='row p-3'>
                                <div className="col-12 text-center text-ticket2">
                                    <img src={development? require('../../images/logo_draft.svg') : require('../../images/logo_EMPRESA.svg')} alt="Logo" style={{maxWidth:"170px"}}/>
                                    <p><strong>{Datos_Empresa.Nombre}<br/>{Datos_Empresa.Sociedad}<br/>{Datos_Empresa.RFC}</strong></p>                                        
                                    <p >COL. C.P.;,.</p>
                                    <span >Tel. Cel.</span>
                                </div>
                            </div>
                            <div className='row p-3'>
                                <div className='col-12 text-ticket2'>
                                    <table>
                                        <tbody style={{borderTop: "solid 2px", borderBottom: "solid 2px"}}>
                                            <tr>
                                                <td>FOLIO: </td>
                                                <td className='text-right'>A00A0CCA4647</td>
                                            </tr>
                                            <tr>
                                                <td>FECHA: </td>
                                                <td className='text-right'>15/08/2022 01:14 PM</td>
                                            </tr>
                                            <br/>
                                            <tr>
                                                <td>Doc. de origen: </td>
                                                <td className='text-right'></td>
                                            </tr>
                                            <tr>
                                                <td>Asesor/a de ventas: </td>
                                                <td className='text-right'>VENTA DE PISO MATRIZ</td>
                                            </tr>
                                            <tr>
                                                <td>Cajero/a: </td>
                                                <td className='text-right'>5,125</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div> 
                            <div className='row pl-3 pr-3'>
                                <div className='col-12 text-ticket2'>
                                    <div className='text-center pb-3'>
                                        <span><strong>DATOS DEL CLIENTE</strong></span>
                                    </div>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td>NOMBRE: </td>
                                                <td className='text-right'>VENTA DE MOSTRADOR</td>
                                            </tr>
                                            <tr>
                                                <td>CLAVE: CA001</td>
                                                <td className='text-right'>RUT: XAXX010101000</td>
                                            </tr>
                                            <tr>
                                                <td>TELÉFONO: </td>
                                                <td className='text-right'></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <br/>
                                </div>
                            </div>
                            <div className='row pl-3 pr-3'>
                            <div className='col-12 text-ticket2'>
                                    <div className='text-center pb-3'>
                                        <span><strong>VENTA CANCELADA</strong></span>
                                    </div>
                                    <table>
                                        <thead style={{borderBottom: "solid 2px"}}>
                                            <tr>
                                                <th>Código</th>
                                                <th className='text-right'>Cant.</th>
                                                <th className='text-right'>UM</th>
                                                <th className='text-right'>Precio</th>
                                                <th className='text-right'>Importe</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td colSpan="5">CEMENTO GRIS DE 50 KGS</td>
                                            </tr>
                                            <tr>
                                                <td>CEMENTO</td>
                                                <td className='text-right'>3</td>
                                                <td className='text-right'>XSA</td>
                                                <td className='text-right'>251.34</td>
                                                <td className='text-right'>$291.55</td>
                                            </tr>
                                            <br/> 
                                            <tr>
                                                <td colSpan="1"></td>
                                                <td colSpan="2"><strong>SUB TOTAL</strong></td>
                                                <td className='text-right' colSpan="2"><strong>251.34</strong></td>
                                            </tr>
                                            <tr>
                                                <td colSpan="1"></td>
                                                <td colSpan="2"><strong>IVA</strong></td>
                                                <td className='text-right' colSpan="2"><strong>40.21</strong></td>
                                            </tr>
                                            <tr>
                                                <td colSpan="1"></td>
                                                <td colSpan="2"><strong>TOTAL</strong></td>
                                                <td className='text-right' colSpan="2"><strong>291.55</strong></td>
                                            </tr>
                                            <br/> 
                                            <tr>
                                                <td colSpan="5">DOSCIENTOS NOVENTA Y UN SOLES 55/100 M.N</td>
                                            </tr>                                             
                                        </tbody>
                                    </table>
                                    <img src={require('../../images/cancelado.png')} alt="Sello" style={{width:"170px", position: "absolute", marginLeft:"15px", marginTop: "-52px"}}/>
                                    <br/> 
                                    <p>Comentarios: <br/>Basado en venta de Counter One<br/>A00A0CCA4647</p> 
                                    <br/>
                                    <br/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-4'></div>

                </div>

            </div>
        )
    }
}

export default TicketCanceled